module.exports = __webpack_public_path__ + "img/selected6-min.749a8d12.png";